import React from "react";
import UnsavedChangesModal from "@dhn/components/molecules/unsaved-changes-modal";

export default function MedicalResultUnsavedChangesModal({
  isOpen,
  onContinueEditing,
  onDiscard,
}) {
  return (
    <UnsavedChangesModal
      isOpen={isOpen}
      onContinueEditing={onContinueEditing}
      onDiscard={onDiscard}
      title="Resultado sin agregar"
      message="Hay información pendiente. Para guardarla en la cita, vuelve y presiona el botón “Agregar resultado”."
      hint="Si cierras ahora, la etiqueta y los archivos seleccionados se perderán."
      continueLabel="Seguir editando"
      discardLabel="Cerrar sin guardar"
    />
  );
}
